import { CircleCheck } from 'lucide-react'
import { SessionManager } from 'utils'

export default function ActionApprove(props) {

    const { text, route_name, onClick } = props

    const permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <CircleCheck size={16} className='action_btn edit_btn text-secondary me-3'
                    onClick={onClick}
                    data-tooltip-id='global-tooltip'
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                    data-tooltip-class-name='tl_green tooltip_msg'
                />
            }
        </>
    )
}